import { type OptionType } from "@vega-core/models/options";

// Tier configuration
export const MAX_TIER_LEVEL = 5;
export const DEFAULT_TIER_LEVEL = "1"; // TODO: Should be a number

// TODO: Move this one to BE
export const TIER_OPTIONS: OptionType[] = Array.from(
  { length: MAX_TIER_LEVEL },
  (_, index) => ({
    label: (index + 1).toString(),
    value: (index + 1).toString(),
  }),
);

export const REASON_FOR_INCLUSION_SEPARATOR = ",";
